import { partnerQueryKeys } from "referralPortal/api/queryKeys";

const NOTIFICATION_QUERY_KEYS = [
  ["notification"],
  ["notificationForNavbar"],
  ["notificationForAccounts"],
  [...partnerQueryKeys.all, "notifications"],
  partnerQueryKeys.notificationCount(),
];

/**
 * A push means the server has a new notification. `refetchType: "all"` also refreshes lists nobody is
 * looking at right now: the client sets refetchOnMount to false, so an inactive list would otherwise
 * open showing the state from before the push.
 */
export const invalidateNotificationQueries = (queryClient) =>
  Promise.all(
    NOTIFICATION_QUERY_KEYS.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey, refetchType: "all" })
    )
  );
